import { render, staticRenderFns } from "./MyWalletSection.vue?vue&type=template&id=cc3c9150&scoped=true"
import script from "./MyWalletSection.vue?vue&type=script&lang=ts"
export * from "./MyWalletSection.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletSection.vue?vue&type=style&index=0&id=cc3c9150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c9150",
  null
  
)

export default component.exports